export const styles = (theme) => ({
  containerBranch: {
    minWidth: theme.spacing(17),
  },
  root: {
    minHeight: "2.3rem",
  },
  selectMenu: {
    padding: "9px",
    fontSize: "1rem",
  },
});
